<template>
  <div>

      <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        :search-input.sync="searchInput"
        :rules="[rules.required]"
        hide-no-data
        hide-selected
        item-text="nazw"
        item-value="id"
        label="Miejscowość*"
        placeholder="znajdź miejscowość"
        return-object
        @keyup="searchCity"
        @change="wybrano"
      ></v-autocomplete>
  </div>
</template>

<script>
  export default {
    name: 'MiastoComponent',
      data: () => ({
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      url: document.querySelector('body').dataset.url,
      items: [],
      searchInput: '',
      rules: {
          required: value => !!value || 'Pole jest wymagane.',
      },
    }),

    methods: {
      searchCity(event) {
        if ((event.key !== 'ArrowDown') && (event.key !== 'ArrowUp') && (event.key !== 'Enter')) {
        this.isLoading = true;
        this.$api
          .getData(`/rejestracja/szukajmiasta?nazwa=${this.searchInput}`)
          .then(response => {
                this.isLoading = false;
                this.items = response.data.data;
            })
          .catch(error => console.log(error));
        }
      },
      wybrano() {
        this.$emit('city', this.model.id);
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
